import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import './index.scss';
import AnimatedLetters from '../AnimatedLetters';
import { useState } from 'react';


const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = ['v', 'a', 'n', ' ', 'b', 'u', 'c', 'h', 'o', 'l', 's', 'k', 'i']
    const jobArray = ['S', 'o', 'f', 't', 'w', 'a', 'r', 'e', ' ', 'D', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r']

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 4000)
    
        
        return () => clearTimeout(timeoutId)
    }, [])
    

    return (
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>i,</span> 
                <br />
                <span className={`${letterClass} _13`}>I</span>
                <span className={`${letterClass} _14`}>'m</span>
                <span className="name-mark">E</span>
                <AnimatedLetters letterClass={letterClass}
                strArray={nameArray}
                idx={15} />
                <br />
                <AnimatedLetters letterClass={letterClass}
                strArray={jobArray}
                idx={22} />
                </h1>
                <h2>Based in Toronto, Canada. Expert in C, Java and Python</h2>
                <Link to="/contact" className='flat-button'>CONTACT ME</Link>
            </div>
            <div className="hero-terminal" aria-label="Developer profile">
                <div className="terminal-bar">
                    <span></span>
                    <span></span>
                    <span></span>
                    <strong>evan.dev</strong>
                </div>
                <div className="terminal-content">
                    <p><span className="terminal-prompt">$</span> whoami</p>
                    <h2>Evan Bucholski</h2>
                    <p className="terminal-muted">software developer · problem solver</p>
                    <p><span className="terminal-prompt">$</span> location</p>
                    <p className="terminal-value">Toronto, Canada</p>
                    <p><span className="terminal-prompt">$</span> stack</p>
                    <div className="terminal-tags">
                        <span>C</span>
                        <span>Java</span>
                        <span>Python</span>
                    </div>
                    <span className="terminal-cursor">_</span>
                </div>
            </div>
        </div>
    )


}

export default Home